import { Reveal } from "./motion";
import { useLang } from "@/i18n/LanguageContext";

// Editorial statement band (replaces the numeric stats strip)
export const StatsStrip = () => {
  const { t } = useLang();
  return (
    <section className="border-y border-vw-silver bg-vw-bg2">
      <div className="mx-auto max-w-[1440px] px-6 md:px-12 py-24 md:py-32">
        <Reveal>
          <div className="vw-eyebrow text-vw-green mb-8">{t.statement.eyebrow}</div>
          <p className="font-serif italic font-light text-vw-green leading-[1.05] tracking-tight text-4xl md:text-6xl lg:text-7xl max-w-[18ch]">
            {t.statement.text}
          </p>
        </Reveal>
      </div>
    </section>
  );
};
